import { CONVERGENCE } from "./event";
import { SPEAKER_COMPANIES, SPEAKERS } from "./speakers";

export interface FaqEntry {
  question: string;
  answer: string;
  /** Sends the reader to the panel the answer is talking about. */
  action?: { href: string; label: string };
}

/** "a, b, c and d" */
function list(items: readonly string[]) {
  if (items.length < 2) {
    return items[0] ?? "";
  }
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

const WORDS = [
  "No",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
];

/** Spelled out so an answer never opens on a numeral. */
function spell(count: number) {
  return WORDS[count] ?? String(count);
}

/**
 * Answers are built from the same constants the page renders, so the count of
 * confirmed speakers and the companies behind them cannot drift out of date.
 */
export const FAQS: readonly FaqEntry[] = [
  {
    question: "Who is Convergence for?",
    answer:
      "The researchers, founders, and operators building the next era of reinforcement learning. It is a curated, invite-only summit, and the host committee reviews the guest list by hand.",
  },
  {
    question: "How do I get an invitation?",
    answer:
      "Registration runs on Luma. Put your name down there and the host committee will follow up with the details.",
    action: { href: CONVERGENCE.lumaUrl, label: "Register on Luma" },
  },
  {
    question: "When and where is it?",
    answer: `${CONVERGENCE.dateLong}, ${CONVERGENCE.hours}. The summit is at the ${CONVERGENCE.venueShort} in ${CONVERGENCE.city}, a few minutes from Montgomery and Embarcadero BART.`,
    action: { href: "#venue", label: "Read more about the location" },
  },
  {
    question: "What does the day look like?",
    answer:
      "Doors, coffee and breakfast networking from 8:00 AM, then sessions through the morning either side of an intermission, and a catered lunch to close at 1:00 PM.",
    action: { href: "#agenda", label: "See the full agenda" },
  },
  {
    question: "Who is speaking?",
    answer: `${spell(SPEAKERS.length)} speakers are confirmed so far, from ${list(
      SPEAKER_COMPANIES.map((company) => company.name),
    )}. Speakers and topics for each session are announced closer to the day.`,
    action: { href: "#speakers", label: "See who is speaking" },
  },
  {
    question: "Is food provided?",
    answer:
      "Yes. Coffee and a light breakfast when doors open, and a catered lunch to close the day.",
  },
];
